export default __webpack_public_path__ + "static/media/meatGradesBG.7d39f0eb.jpg";